import type { ExchangeStatus } from '../types';

/**
 * Сравнение снимков канала `exchanges` по ЗНАЧИМЫМ полям.
 *
 * Канал шлёт полный список бирж на каждое сообщение, и в нём всегда что-то
 * «меняется»: last_update и lag_ms тикают непрерывно. Страницы этих двух полей
 * не показывают, но setState с новым массивом перерисовывал терминал и сканер
 * целиком и заново прогонял фильтры (от списка бирж зависит tradableSet).
 * Сравниваем только то, что реально попадает на экран.
 */
export function sameExchanges(a: ExchangeStatus[], b: ExchangeStatus[]): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const x = a[i], y = b[i];
    if (x.name !== y.name
      || x.connected !== y.connected
      || x.symbols !== y.symbols
      || !!x.supports_trading !== !!y.supports_trading
      || (x.error || null) !== (y.error || null)) return false;
  }
  return true;
}

/** Строковый ключ набора торгуемых бирж — стабильная зависимость для useMemo:
 *  новый массив с тем же составом не должен пересобирать Set и всё, что от него
 *  считается. */
export function tradableKey(list: ExchangeStatus[]): string {
  return list.filter(e => e.supports_trading).map(e => e.name).sort().join(',');
}
